// src/components/SearchToolbar.tsx - Dedicated search row below nav
import React from 'react';
import { Box, Container, Chip } from '@mui/material';
import GlobalSearch from './GlobalSearch';

interface SearchToolbarProps {
  onResultClick?: () => void;
  onSearchOpen?: () => void;
}

const SearchToolbar: React.FC<SearchToolbarProps> = ({ onResultClick, onSearchOpen }) => {
  return (
    <Box 
      sx={{ 
        backgroundColor: 'background.paper',
        borderBottom: '1px solid',
        borderColor: 'divider',
        py: 1
      }}
    >
      <Container maxWidth={false} sx={{ maxWidth: '1400px' }}>
        <Box sx={{ 
          display: 'flex', 
          alignItems: 'center', 
          justifyContent: 'center',
          gap: 2,
          maxWidth: 900,
          mx: 'auto',
          px: 2
        }}>
          {/* Full width search */}
          <Box sx={{ flexGrow: 1, maxWidth: 800 }}>
            <GlobalSearch 
              onResultClick={onResultClick}
              placeholder="Search Performances, Bands, Resources, Strands, Venues, Inventory, PO numbers, etc"
            />
          </Box>
          
          {/* Search shortcut */}
          {onSearchOpen && (
            <Chip
              label="⌘K"
              size="small"
              variant="outlined"
              onClick={onSearchOpen}
              sx={{ 
                cursor: 'pointer',
                display: { xs: 'none', sm: 'flex' },
                '&:hover': { backgroundColor: 'action.hover' }
              }}
            />
          )}
        </Box>
      </Container>
    </Box>
  );
};

export default SearchToolbar;